export default __webpack_public_path__ + "static/Turbinado-Bold-710c4df2c23526d06704637f325d9103.woff2";